import { APIJobs } from '@platform/client';
import { EmailTabSection } from '../../components/EmailTabSection';

export const MatchEmailTabContent = ({ matchGroupId }: { matchGroupId: number }) => {
  const {
    data: emailData,
    isLoading,
    isError,
    isSuccess,
  } = APIJobs.useGetMatchingEmailJobs(matchGroupId);

  return (
    <EmailTabSection
      data={emailData}
      isLoading={isLoading}
      isError={isError}
      isSuccess={isSuccess}
      recordType='matching'
    />
  );
};
